<template>
  <div class="content-empty-text">{{ msg }}</div>
</template>
<script>
export default {
  props: {
    msg: {
      type: String,
      default: '暂无数据'
    }
  }
}
</script>
<style lang="scss" scoped>
.content-empty-text{
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  color: rgba(255, 255, 255, .3);
}
</style>
